<template>
  <div class="min-h-screen bg-black text-white py-8 px-4 md:px-8 md:mt-16" :key="isFighter">
    <section
      class="w-full md:w-1/2 mx-auto"
    >
      <div
        class="flex flex-col items-centergap-6 container"
      >
        <!-- Avatar -->
        <div class="w-full flex justify-center mb-2">
          <div
            class="w-32 h-32 rounded-full overflow-hidden border-2 border-[#d20a0a] shadow-md flex justify-center"
          >
            <img
              :src="customer?.avatar"
              alt="Avatar"
              class="w-full h-full object-cover"
            />
          </div>
        </div>

        <!-- Dados e formulário -->
        <div class="flex-1 w-full">
          <h2 class="text-3xl font-bold text-center text-white mb-6">
            Olá, {{ customer?.name }}
          </h2>

          <div class="bg-zinc-900 p-6 rounded-xl shadow-md font-inter text-left">
            <form class="space-y-4">
              <div v-if="customer?.name">
                <label class="block text-sm text-gray-300 mb-1">Nome</label>
                <input
                  v-model="customer.name"
                  type="text"
                  class="w-full rounded-lg p-2 bg-zinc-800 text-white border border-zinc-700"
                />
              </div>

              <div v-if="customer?.email">
                <label class="block text-sm text-gray-300 mb-1">E-mail</label>
                <input
                  v-model="customer.email"
                  type="email"
                  class="w-full rounded-lg p-2 bg-zinc-800 text-white border border-zinc-700"
                />
              </div>

              <div>
                <label class="block text-sm text-gray-300 mb-1">Nova senha</label>
                <input
                  v-model="dataShared.state.profile.p_password"
                  type="password"
                  class="w-full rounded-lg p-2 bg-zinc-800 text-white border border-zinc-700"
                />
              </div>

              <div class="flex justify-center">
                <button
                  type="submit"
                  @click.prevent="updateProfileData()"
                  class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-6 rounded-lg"
                >
                  Salvar Alterações
                </button>
              </div>
            </form>
          </div>

        </div>
      </div>
    </section>

    <!-- adquiridos -->
    <section class="px-6 md:px-20 py-10">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        EVENTOS ADQUIRIDOS
      </h2>

        <div v-if="customer?.purchases?.length && customer?.purchases[0]?.event">
          <Carrossel>
            <CardEventoPreview
              v-for="(item, index) in customer?.purchases"
              :key="index"
              :image="
                customer?.purchases[index]?.event?.banner !== null || customer?.purchases[index]?.event?.banner !== '[]' || customer?.purchases[index]?.event?.banner !== undefined
                ? fileUrl + customer?.purchases[index]?.event?.banner 
                : banner"
              :title="customer?.purchases[index]?.event?.title"
              :date="formatDate(customer?.purchases[index]?.event?.date)"
              :live="customer?.purchases[index]?.event?.is_live"
              @click="watchEvent(customer?.purchases[index]?.event)"
            />
          </Carrossel>
        </div>
        <div class="w-full py-3" v-else>
          Ainda não há eventos adquiridos
        </div>
    </section>

    <!-- participações -->
    <section class="px-6 md:px-20 py-10" v-if="isFighter == true">
      <div class="flex gap-x-3">
        <h2 class="text-white text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
          MEUS EVENTOS
        </h2>
        <h2 class="text-gray-600 text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
          PARTICIPAÇÕES
        </h2>
      </div>

      <div v-if="customer?.coupon?.length > 0">
        <Carrossel>
          <CardEventoPreview
            v-for="(item, index) in customer?.coupon"
            :key="index"
            :image="
              item?.event?.banner !== null || item.event?.banner !== '[]' || item.event?.banner !== undefined
              ? fileUrl + item.event?.banner 
              : banner
            "
            :title="item?.event?.title"
            :date="formatDate(item.event?.date)"
            :live="item.event?.is_live"
            @click="goSponsorshipPage(item.event?.id, item)"
          />
        </Carrossel>
      </div>
      
      <div class="w-full py-3" v-else>
        Sem participações
      </div>
    </section>

    <!-- patrocícios -->
    <!-- <section class="px-6 md:px-20 py-10" v-if="isFighter == true">
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        patrocínios
      </h2>

      <div class="relative overflow-x-auto">
        <div class="flex gap-4 p-1">
          <CardEventoPreview
            v-for="(item, index) in 10" :key="index"
            image="https://blogs.opovo.com.br/clubedaluta/wp-content/uploads/sites/53/2017/10/CARLOS-EDUARDO-CACHORRAO.jpg"
            title="LFA 153: Mariscal Porta vs Faria Montanha"
            date="17/05/2025"
            :live="true"
          />
        </div>
      </div>
    </section> -->

    <!-- PATROCINADORES -->
    <!-- <section class="px-6 md:px-20 py-10" v-else>
      <h2 class="text-xl md:text-2xl font-semibold mb-4 uppercase text-start">
        PATROCINADORES
      </h2>

      <div class="relative overflow-x-auto">
        <div class="flex gap-4 p-1">
          <CardEventoPreview
            v-for="(item, index) in 7" :key="index"
            image="https://blogs.opovo.com.br/clubedaluta/wp-content/uploads/sites/53/2017/10/CARLOS-EDUARDO-CACHORRAO.jpg"
            title="LFA 153: Mariscal Porta vs Faria Montanha"
            date="17/05/2025"
            :live="true"
          />
        </div>
      </div>
    </section> -->

    <!-- be a fight -->
    <section
      class="relative bg-fixed bg-center bg-cover md:h-auto h-[70vh]"
      :key="isFighter"
      v-if="isFighter == false || isFighter == null"
      :style="{
        backgroundImage: `url(${bgDownload})`,
      }"
    >
      <div class="absolute inset-0 bg-black/70 z-0"></div>

      <main class="relative z-[1] flex-col w-full">
        <section class="w-full flex justify-center">
          <div class="md:w-1/2 w-full text-white">
            <TitleSection
              :customWTitle="true"
              :customColor="'white'"
              :title="'Solicitar acesso de lutador'"
            />
          </div>
        </section>

        <div
          class="flex flex-col justify-center gap-y-32 items-center p-1 font-berthold-force w-full md:h-[80vh] md:mt-0 mt-10"
        >
          <div>
            <h2 class="text-4xl">
              Participe de eventos exclusivos da Number One
            </h2>
          </div>

          <div>
            <div
              class="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0 cursor-pointer"
            >
              <button
                @click.prevent="beAFighter()"
                class="cursor-pointer inline-flex justify-center items-center py-2 px-10 text-base font-bold tracking-wide text-white bg-[#d20a0a] border-2 border-red-700 hover:bg-white hover:text-red-700 transition-colors duration-300"
              >
                <label
                  class="pb-3 mt-2 text-3xl uppercase font-berthold-force font-bold tracking-wide cursor-pointer"
                >
                  SEJA MEMBRO
                </label>
              </button>
            </div>
          </div>
        </div>
      </main>
    </section>

  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import CardEventoPreview from '../auth/components/CardEventoPreview.vue'
import SharedService from '@/shared/services/shared'
import { dataShared } from '@/shared/store'

import bgDownload from '@/assets/bgDownload.webp'
import TitleSection from '@/shared/components/__partials/TitleSection.vue'
import { showToast as toast } from '@/helpers/UseToasts'

import { formatDate } from '@/utils/formaters'
import router from '@/router'
import Carrossel from '../auth/components/_partials/Carrossel.vue'

const banner = require('@/assets/logo/icon.png')
const customer = computed(() => dataShared.getters.getDataByUserLogged)

const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const isFighter = computed(() => customer.value?.is_fighter)
const customerId = computed(() => customer.value?.id)

function beAFighter () {
  dataShared.dispatch('activeLoading')

  SharedService.beAFighter(customerId.value)
    .then(res => {
      if (res.data.success) {
        toast(
          'Aviso',
          res.data.message,
          'success'
        )
      }

      dataShared.dispatch('desactiveLoading')
    }).catch(err => {
      dataShared.dispatch('desactiveLoading')

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      if (err?.response?.data?.error && err.response.data.status === 404) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado com sua solicitação',
        'error'
      )
    })
}

function goSponsorshipPage (eId, payload) {
  router.push({
    name: 'purchase',
    params: { id: eId },
    query: {
      fighter: payload?.fighter_id,
      affiliate: payload?.secret
    }
  })
}

async function watchEvent (event) {
  await SharedService.watchEventById(event?.id)
    .then(res => {
      if (res.data.success == false) {
        dataShared.dispatch('setEventToPurchase', event?.id)
        toast('Aviso', 'Adquira acesso a este evento', 'info')
        return router.push(`/purchase/${event?.id}/event`)
      }

      dataShared.dispatch('setLiveActive', event?.id)
      router.push(`/live/${event?.id}`)
    }).catch(err => {
      console.log(err)
    })
}

async function updateProfileData () {
  dataShared.dispatch('activeLoading')
  
  const data = {
    p_name: dataShared.state.dataUserLogged?.name,
    p_email: dataShared.state.dataUserLogged?.email,
    p_password: dataShared.state.profile.p_password
  }

  await SharedService.updateData(data)
    .then(res => {
      if(res?.data.success) {
        toast(
          'Sucesso',
          res.data.message,
          'success'
        )
      }
    }).catch(err => {
      dataShared.dispatch('desactiveLoading')

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado com sua solicitação',
        'error'
      )
    })

  dataShared.dispatch('desactiveLoading')
}

onMounted(async () => {
  dataShared.dispatch('activeLoading')
  await dataShared.dispatch('fetchLoggedUser')
  dataShared.dispatch('desactiveLoading')
})

</script>

<style scoped>
::-webkit-scrollbar {
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #d20a0a;
  border-radius: 10px;
}
</style>
